import { dataFetchingClient } from './DataFetchingClient';
import { produce } from 'immer';
export const getQueryFieldName = query => {
  return query.definitions[0].name.value;
};
export const queryDataFromCache = (query, variables) => {
  const queryDataWrapper = dataFetchingClient.cache.readQuery({
    query,
    variables
  });
  if (queryDataWrapper) {
    if ('result' in queryDataWrapper) {
      return queryDataWrapper.result;
    }
  }
  return null;
};
export const updateCache = (query, updateFn, variables) => {
  dataFetchingClient.cache.writeQuery({
    query,
    data: {
      result: produce(queryDataFromCache(query, variables) || {}, updateFn)
    },
    variables
  });
};